import clone from 'clone';
import { newInvoice } from './config';
import actions from './actions';

const initState = {
  invoices: [],
  initialInvoices: false,
  currentInvoice: {},
  editableInvoice: {},
  isNewInvoice: false,
  enableEditView: false,
  userVentas: [],
  passedPedidosToInvoices: [],
  paginationInfo: {},
  loadingInvoices: false,
  // DIAN
  dianLoading: false,
  dianResultado: null,   // { resultados, errores, msg }
};

export default function cardReducer(state = initState, { type, ...action }) {
  switch (type) {
    case actions.UPDATE_INVOICE: {
      const currentInvoice = action.invoice
        ? action.invoice
        : state.currentInvoice;
      return {
        ...state,
        invoices: action.invoices,
        currentInvoice: clone(currentInvoice),
        initialInvoices: true,
        isNewInvoice: false,
        enableEditView: false,
        loadingInvoices: false,
      };
    }
    case actions.GET_INVOICE:
      return {
        ...state,
        loadingInvoices: true,
        invoices: [],
      };
    case actions.SELECT_CURRENT_INVOICE: {
      const invoices = state.invoices;
      // la logica siguiente decide si la accion requerida es para ver o para crear factura
      const factura = invoices.filter(item => item._id === action.id);
      const isNewInvoice = factura.length === 0;
      const currentInvoice = isNewInvoice
        ? {
          id: action.id,
          _id: action.id,
          number: `#${action.id}`,
          key: action.id,
          ...newInvoice,
        }
        : factura[0];
      const enableEditView = isNewInvoice;
      return {
        ...state,
        currentInvoice,
        isNewInvoice,
        enableEditView,
        editableInvoice: currentInvoice,
        userVentas: []
      };
    }
    case actions.TOGGLE_VIEW:
      return {
        ...state,
        enableEditView: action.view,
        editableInvoice: clone(state.currentInvoice),
      };
    case actions.UPDATE_EDIT_INVOICE:
      return {
        ...state,
        userVentas: []
      };
    case actions.SET_CURRENT_INVOICE:
      return {
        ...state,
        currentInvoice: action.invoice,
        userVentas: []
      };
    case actions.INVOICE_USER:
      return {
        ...state,
        userVentas: action.payload
      };
    case actions.PASS_PEDIDOS_TO_INVOICES:
      return {
        ...state,
        passedPedidosToInvoices: action.payload,
        enableEditView: true,
        isNewInvoice: true,
      }
    case actions.SET_PAGINATION_INFO:
      return {
        ...state,
        paginationInfo: action.payload,
      };
    case actions.SET_DIAN_LOADING:
      return { ...state, dianLoading: action.payload };
    case actions.DIAN_PREPARAR_SUCCESS:
      return { ...state, dianLoading: false, dianResultado: action.payload };
    case actions.DIAN_PREPARAR_ERROR:
      return { ...state, dianLoading: false, dianResultado: { error: action.msg } };
    default:
      return state;
  }
}
